import React from "react";
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
// import _ from "lodash";

// @material-ui/icons
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";

// import articoli from "api/articoli.json";

const useStyles = makeStyles(shippingAddressStyle);

function BaseView(props) {
  const {
    children,
    buttons,
    // backLinks,
    title
    // customStyle
  } = props;

  // const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <MobileWrapper type={"contacts"} showButtons buttons={buttons}>
        <div className={classes.container}>
          <Card className={classes.card}>
            <CardBody>
              <CardHeader>
                <h1 className={classes.title}>{title}</h1>
              </CardHeader>
              <CardBody>{children}</CardBody>
            </CardBody>
            {/* ******* WEB >= 960 ********** */}
            <Hidden smDown implementation="css">
              <div className={classes.containerButtons}>
                <GridContainer>
                  {buttons.map(element => {
                    return (
                      <GridItem
                        xs={12}
                        sm={buttons.length === 1 ? 12 : 6}
                        md={buttons.length === 1 ? 12 : 6}
                        lg={buttons.length === 1 ? 12 : 6}
                        style={{ textAlign: "center" }}
                        key={element.path}
                      >
                        {/* <Link to={element.path}> */}
                          <Button
                            round
                            size="sm"
                            // color="github"
                            // className={classes.buttonBig}
                            // color="info"
                            onClick={element.onClick}
                            style={{
                              backgroundColor: element.buttonStyle
                            }}
                          >
                            <span className={classes.buttonTextNormal}>
                              {element.text}
                            </span>
                          </Button>
                        {/* </Link> */}
                      </GridItem>
                    );
                  })}
                </GridContainer>
              </div>
            </Hidden>
          </Card>
        </div>
      </MobileWrapper>
    </>
  );
}

BaseView.propTypes = {
  customStyle: PropTypes.object,
  buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
  // backLinks: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired
};

BaseView.defaultProps = {
  customStyle: {}
};

export default withRouter(BaseView);
